<template>
	<div :class='{"pc":!flag == true,"mobile":!flag == false}'>
		<div class="banner">
			<video src="../assets/pinpaifupin.mp4" controls="controls" width="1200"></video>
			<img v-if="!flag" src="../assets/bannar-fuping.png" alt="">
			<img class="banner-mobile" v-else src="../assets/bannar-fuping-phone.png" alt="">
		</div>
		<div class="infoBox">
			<img src="../assets/shidapinpai.jpg" alt="">
			<div class="info">
				原农业部党组成员、国务院参事室特约研究员、中国农产品市场协会会长 张玉香，广东省农业农村厅副厅长（正厅职）陈东为“粤字号”2019年度产业扶贫十大农产品区域公用品牌授牌。
			</div>
		</div>
		<div class="infoBox">
			<img src="../assets/chanxiaoduijie.png" alt="">
			<img src="../assets/chanxiaoduijie.jpg" alt="">
			<div class="info" style="text-align:center;text-indent:0px">
				扶贫农产品产销对接签约  
			</div>
		</div>
		
	</div>
</template>
<script>
	export default {
		name: 'app',
		data() {
			return {
				flag: navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
			}
		},		
		methods: {
			
		},
		mounted() {
		
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.pc{
		.banner{
			padding-top:300px;
			position: relative;
			height: 1150px;
			img{
				position: absolute;
				left: 50%;
				top: 110px;
				margin-left: -960px;
			}
			video{
				object-fit:fill;
				position: absolute;
				left: 50%;
				top: 500px;
				margin-left: -600px;
				z-index: 1;
				box-shadow: 0px 4px 14px #fffcd2;
				border: 1px solid red;
			}
		}
		.infoBox{
			margin-top: 20px;
			img{
				display: block;
				margin: 0 auto;
			}
			.info{
				margin: 0 auto;
				margin-top: 20px;
				margin-bottom: 80px;
				width: 800px;
				font-size: 18px;
				line-height: 34px;
				text-indent: 40px;
				text-align: justify;
			}
		}
	}
	.mobile {
		width: 100%;
		height: 100%;
		margin-top: 1.302083rem;
		position: relative;
		overflow: hidden;
		.banner{
			width: 100%;
			position: relative;
			img{
				width: 100%;
				position: relative;
			}
			video{
				object-fit:fill;
				position: absolute;
				top: -40px;
				width: 100%;
				z-index: 1;
				box-shadow: 0px 4px 14px #fffcd2;
				border: 1px solid red;
				margin-top: 200px;
			}
		}
		.infoBox{
			padding: 10px;
			font-size: 18px;
			line-height: 34px;
			text-align: justify;			
			img{
				width: 100%;
			}
			.info{
				text-indent: 40px;
				margin-bottom: 40px;
				margin-top: 18px;
			}
		}
	}
</style>
